import { chakra } from '@chakra-ui/react'

export const MIC_OPTION_GAP = 16
export const MicOption = chakra('button', {
    baseStyle: ({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: `${MIC_OPTION_GAP}px`,
        color: theme.palette.toolbar.extrasTextColor,
        fontSize: '18px',
        lineHeight: '28px',
        padding: '16px 0',
        width: '100%',
    }),
})

export const CHECK_ICON_SIZE = 18
export const MicOptionLabel = chakra('span', {
    baseStyle: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textAlign: 'left',
        width: `calc(100% - ${MIC_OPTION_GAP + CHECK_ICON_SIZE}px)`,
    },
})
